<script>
  import DpNotificationPersist from "./DpNotificationPersist";

  export default {
    name: "DpFeedforward",
    mixins: [DpNotificationPersist]
  }
</script>

<i18n>
  {}
</i18n>

